var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navTop"},[_c('van-nav-bar',{staticClass:"nav-bar",attrs:{"title":_vm.title,"left-arrow":"","border":false,"fixed":"","placeholder":""},on:{"click-left":_vm.onClickLeft}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }